import axios from "axios";
import { getAbstractService } from "./AbstractService";


export async function upload(id: string, file: File) {
	const formData = new FormData();
	formData.append("file", file);
	formData.append("filename", file.name);
	const res = await getAbstractService(
		{
			path: 'auftrag/'+id+'/upload',
			type: 'post',
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			withCredentials: true,
			data: formData,
			//onUploadProgress: progressEvent,
			failCallback: (error: any) => {
				alert(error.message);
			}
		}
	);
	return res;
}


export async function downloadFile(uid: string) {
	
	const res = await axios({
		method: 'post',
		url: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + 'file/download/' + uid,
		responseType: 'arraybuffer',
		withCredentials: true,
	});
		
	return res;
}

